import { ConstantSumCluster, PollType, RankingOption, SavedConfigurations } from "../pollTypes";

export const normalizeClusters = (items: ConstantSumCluster[]) =>
  [...items]
    .sort((a, b) => a.order - b.order)
    .map((cluster) => ({
      label: cluster.label.trim(),
      description: cluster.description?.trim() ?? "",
      image_url: cluster.image_url ?? "",
      order: cluster.order,
      subCategories: [...(cluster.subCategories || [])]
        .sort((a, b) => a.order - b.order)
        .map((sub) => ({
          label: sub.label.trim(),
          description: sub.description?.trim() ?? "",
          order: sub.order,
        })),
    }));

export const normalizeRankingOptions = (items: RankingOption[]) =>
  [...items]
    .sort((a, b) => a.order - b.order)
    .map((option) => ({
      label: option.label.trim(),
      description: option.description?.trim() ?? "",
      image_url: option.image_url ?? "",
      order: option.order,
    }));

export const areConfigurationsEqual = (
  type: PollType,
  current?: SavedConfigurations[PollType],
  baseline?: SavedConfigurations[PollType],
) => {
  if (!current && !baseline) return true;
  if (!current || !baseline) return false;

  if (type === "constant_sum_two_level") {
    const currentClusters = normalizeClusters((current as { clusters: ConstantSumCluster[] }).clusters || []);
    const baselineClusters = normalizeClusters((baseline as { clusters: ConstantSumCluster[] }).clusters || []);
    return JSON.stringify(currentClusters) === JSON.stringify(baselineClusters);
  }

  const currentOptions = normalizeRankingOptions((current as { options: RankingOption[] }).options || []);
  const baselineOptions = normalizeRankingOptions((baseline as { options: RankingOption[] }).options || []);
  return JSON.stringify(currentOptions) === JSON.stringify(baselineOptions);
};
